import styled from "styled-components";

const NewQuoteWrapper = styled.div`
  padding-bottom: 12px;
`;

export { NewQuoteWrapper };
